<template>
  <div class="grid-component columns is-multiline" :id="fieldSet.id">
    <!-- For each column with field inside  -->
    <div v-for="field in fieldSet.fields"
      :key="field.uid"
      class="form-field column"
      :class="getFieldSetColumnsClass(fieldSet.layout.columns)">
      <form-field-component
        :field="field"
        :formData="formData">
      </form-field-component>
    </div>
  </div>
</template>
<script>
  import FieldSet from '@/classes/form/FormFieldSet'
  import FormData from '@/classes/form/FormData'
  import FormFieldComponent from '@/components/form/field/FormFieldComponent'

  export default {
    name: 'grid-form-component',
    components: {
      FormFieldComponent
    },
    props: {
      fieldSet: {
        type: FieldSet,
        required: true
      },
      formData: {
        type: FormData
      }
    },
    methods: {
      getFieldSetColumnsClass (columns) {
        return 'is-' + (12 / columns)
      }
    }
  }
</script>

<style lang="sass" scoped>
  .form-field
    margin-bottom: 15px
</style>
